









import { Component, Prop, Vue } from 'vue-property-decorator';
import LoadingAnimation from '@/components/loading/LoadingAnimation.vue';

@Component({
    components: {
        LoadingAnimation,
    },
})
export default class Loading extends Vue {
    @Prop(String) readonly status!: string;
}
